// extracted by css-extract-rspack-plugin
export default {"alignRight":"_bf110d94","alignCenter":"_e36c055f"};